module.exports = __webpack_public_path__ + "static/media/skill_ns.c65e3746.png";